import getCookieByName from 'app/utils/getCookieByName';
import { memoize } from 'lodash';

const getQuery = memoize((search) => new URLSearchParams(search));

// Try to get GA_ID from cookies data
function getGoogleAnalyticsClientId() {
  const queryParams = getQuery(window.location.search);
  const queryGaId = queryParams.get('ga_id');
  const gaCookies = getCookieByName('_ga');
  const guestyMuid = getCookieByName('guesty-muid');

  const gaId = queryGaId || gaCookies?.split(`GA1.2.`)[1] || '';
  return gaId || window?.gaGlobal?.vid || guestyMuid;
}

// Extract `utm_*` data either from URL or cookies
function getUTMDetails() {
  const queryParams = getQuery(window.location.search);
  const cookiesData = getCookieByName('guesty-utms');
  const utmDetailsString = decodeURIComponent(cookiesData || '{}');
  const json = JSON.parse(utmDetailsString);

  return {
    utm_source: queryParams.get('utm_source') || json.utm_source,
    utm_medium: queryParams.get('utm_medium') || json.utm_medium,
    utm_campaign: queryParams.get('utm_campaign') || json.utm_campaign,
    utm_content: queryParams.get('utm_content') || json.utm_content,
    utm_term: queryParams.get('utm_term') || json.utm_term,
  };
}

function getCcId() {
  const queryParams = getQuery(window.location.search);
  const cookieCcId = getCookieByName('cc_id');
  const queryCcId = queryParams.get('cc_id');

  return cookieCcId ?? queryCcId;
}

class Analytics {
  /**
   * @return Omit<RegistrationData, 'email | firstName | lastName  promoCode'>
   */
  static getDTO() {
    const queryParams = getQuery(window.location.search);
    const source = queryParams.get('gfh_lead_source');
    const fbclid = queryParams.get('fbclid');
    const gclid = queryParams.get('gclid');

    const gcid = getGoogleAnalyticsClientId();
    const guestyUTMs = getUTMDetails();
    const ccId = getCcId();

    return {
      ga_client_id: `ga_${gcid}`,
      source,
      last_click_path: getCookieByName('last_click_path'),
      last_click: getCookieByName('last_click'),
      fbclid,
      gclid,
      cc_id: ccId,
      ...guestyUTMs,
    };
  }
}

export default Analytics;
